<adapt-dialog [maxWidth]="1000">
    <h3 adapt-dialog-title>Manage excluded people</h3>

    <div adapt-dialog-content
         class="d-flex flex-column flex-lg-row">
        @if (ImplementationKitArticle.CulturalFrameworkCohort) {
            <div [adaptCollapsible]="ImplementationKitArticle.CulturalFrameworkCohort"
                 class="left-column d-block pe-3 me-lg-4 mb-4 mb-lg-0">
                <adapt-styled-implementation-kit [articleId]="ImplementationKitArticle.CulturalFrameworkExcludedPeople"
                                                 contentStyle="embedded"></adapt-styled-implementation-kit>
            </div>
        }

        <div class="d-flex flex-column mt-4 mt-lg-0 right-column">
            <dx-list class="dx-list-boxed h-auto"
                     [dataSource]="culturalExclusions"
                     [hoverStateEnabled]="false"
                     [focusStateEnabled]="false"
                     [activeStateEnabled]="false"
                     [allowItemDeleting]="true"
                     (onItemDeleted)="removeCulturalExclusion($event)"
                     noDataText="No people have been excluded from cultural statistics"
                     data-test="excluded-people-list">
                <div *dxTemplate="let culturalExclusion of 'item'"
                     class="d-flex align-items-center gap-2">
                    @if (culturalExclusion.person) {
                        <adapt-link-person [person]="culturalExclusion.person"
                                           [showImage]="true"
                                           [linkDisabled]="true"
                                           imageSize="sm"></adapt-link-person>
                        @if (personHasCulturalLeader(culturalExclusion.person)) {
                            <i class="fal fa-fw fa-exclamation-triangle text-warning"
                               adaptTooltip="This person will be removed from their cultural cohort"></i>
                        }
                    }
                </div>
            </dx-list>

            <adapt-select-person [filter]="filterExcludedPeople"
                                 (personChange)="onPersonSelected($event)"
                                 data-test="select-person-excluded"></adapt-select-person>

            @if (cohortsToBeEnded.length > 0) {
                <div class="alert alert-warning mt-3"
                     role="alert">
                    The following people will be removed from being a
                    {{ configuration.primaryName }}, as this will cause their {{ configuration.secondaryCollectionName }} to be empty:
                    <ul>
                        @for (culturalLeader of cohortsToBeEnded; track culturalLeader.personId) {
                            <li>
                                <adapt-link-person [person]="culturalLeader"
                                                   [showImage]="false"
                                                   [linkDisabled]="true"></adapt-link-person>
                            </li>
                        }
                    </ul>

                    <div class="mt-3">
                        <dx-check-box [value]="checkboxConfirmation"
                                      (valueChange)="checkboxConfirmation = $any($event)"
                                      text="Confirm that these people will be removed from being a {{ configuration.primaryName }}"
                                      data-test="confirm-checkbox"></dx-check-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [discardConfirmationInstance]="instance"
                                   [saveIsDisabled]="cohortsToBeEnded.length > 0 && !checkboxConfirmation"></adapt-standard-dialog-buttons>
</adapt-dialog>
